<template>
  <article>
    <div style="background:#eee;padding: 20px;width:1500px;">
      <Card :bordered="false">
        <h4 slot="title">身份验证</h4>
        <Row>
          <Col span='10'>
            <h5>身份证正面（号码面）</h5>
            <Upload ref="uploadFirstCardImg" name="file" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="cardImgFirstFormatError"
              :max-size="4096" :before-upload="cardImgFirstBeforeUpload" action="">
              <div v-if="!cardInfo.cardFrontImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>身份证正面（号码面）</p>
              </div>
              <div v-if="cardInfo.cardFrontImg" class="img-box">
                <img class="img" :src="'data:image/jpeg;base64,'+cardInfo.cardFrontImg" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>证件照正面</p>
                </div>
              </div>
            </Upload>
          </Col>
          <Col span='8'>
            <h5>身份证反面（国徽面）</h5>
            <Upload ref="uploadSecondCardImg" name="file" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="cardImgSecondFormatError"
              :max-size="4096" :before-upload="cardImgSecondBeforeUpload" action="">
              <div v-if="!cardInfo.cardBackImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>身份证反面（国徽面）</p>
              </div>
              <div v-if="cardInfo.cardBackImg" class="img-box">
                <img class="img" :src="'data:image/jpeg;base64,'+cardInfo.cardBackImg" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>证件照反面</p>
                </div>
              </div>
            </Upload>
          </Col>
        </Row>
        <Form>
          <FormItem class="tableForm" label="姓名：" :label-width="100">
            <span>{{cardInfo.userName || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="身份证号：" :label-width="100">
            <span>{{cardInfo.cardId || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="审核状态：" :label-width="100">
            <span>{{['未验证','已验证','待验证','验证不通过'][cardInfo.isAuth] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="原因：" :label-width="100">
            <span>{{cardInfo.authFailReason || '-'}}</span>
          </FormItem>
        </Form>
        <Row>
          <Button :disabled="!(cardInfo.cardBackImg && cardInfo.cardFrontImg) || cardInfo.isAuth == 1 || cardInfo.isAuth == 2" :loading="btnLoading.omsCardBtn" @click="omsCardAudit">使用照片审核</Button>
          <Button @click="cardVerifyBtn">人工审核身份证</Button>
        </Row>
      </Card><br>
      <Card :bordered="false">
        <h4 slot="title">人脸识别验证</h4>
        <Row>
          <Col span='10'>
            <Upload ref="uploadFaceImg" name="file" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="faceImgFormatError"
              :max-size="4096" :before-upload="faceImgBeforeUpload" action="">
              <div v-if="!faceInfo.faceRecognitionImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>人脸识别照片</p>
              </div>
              <div v-if="faceInfo.faceRecognitionImg" class="img-box">
                <img class="img" :src="'data:image/jpeg;base64,'+faceInfo.faceRecognitionImg" alt="" width="100%">
                 <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>人脸识别照片</p>
                </div>
              </div>
            </Upload>
          </Col>
        </Row>
        <Form>
          <FormItem class="tableForm" label="审核状态：" :label-width="100">
            <span>{{['未验证','待验证','已验证','验证不通过'][faceInfo.isFaceRecognized] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="原因：" :label-width="100">
            <span>{{faceInfo.recognitionFailReason || '-'}}</span>
          </FormItem>
        </Form>
        <Row>
          <Button :disabled="!(faceInfo.faceRecognitionImg) || cardInfo.isAuth !=1 || faceInfo.isFaceRecognized==2" :loading="btnLoading.omsFaceBtn" @click="omsFaceAudit">使用照片审核</Button>
          <Button @click="faceVerifyBtn">人工审核人脸识别</Button>
        </Row>
      </Card>
      <br>
       <!-- 头像照片 -->
      <Card :bordered="false">
        <h4 slot="title">头像照片</h4>
        <Row>
          <Col span='10'>
            <div class="cardImg">
              <div class="upload-box" v-if="cardInfo.iconImg">
                <img class="img" :src="imgHost+cardInfo.iconImg" alt="" width="100%">
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
    <Modal v-model="cardVerifyModel.display" :loading="true" ref="cardVerifyModel" title="人工审核身份证" ok-text="提交" @on-ok="subCard">
      <Form ref="cardVerifyForm" :model="cardVerifyModel.data" :rules="cardVerRules">
        <FormItem label="姓名" :label-width="85" prop="name">
          <Input v-model="cardVerifyModel.data.name"></Input>
        </FormItem>
        <FormItem label="身份证号" :label-width="85" prop="cardId">
          <Input v-model="cardVerifyModel.data.cardId"></Input>
        </FormItem>
        <FormItem label="审核状态" :label-width="85" prop="status">
          <Select v-model="cardVerifyModel.data.status" transfer>
            <Option :value="0">未验证</Option>
            <Option :value="1">已验证</Option>
            <Option :value="2">待验证</Option>
            <Option :value="3">验证不通过</Option>
          </Select>
        </FormItem>
        <FormItem label='原因' :label-width="85" prop="cardReason">
          <Input v-model="cardVerifyModel.data.cardReason" :maxlength="200"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="faceVerifyModel.display" :loading="true" title="人工审核人脸识别" ok-text="提交" @on-ok="subFace">
      <Form :model="faceVerifyModel" :rules="faceVerRules" ref="faceVerifyForm">
        <FormItem label="审核状态" :label-width="85">
          <Select v-model="faceVerifyModel.status" transfer>
            <Option :value="0">未验证</Option>
            <Option :value="1">待验证</Option>
            <Option :value="2">已验证</Option>
            <Option :value="3">验证不通过</Option>
          </Select>
        </FormItem>
         <FormItem label='原因' :label-width="85" prop="faceReason">
          <Input v-model="faceVerifyModel.faceReason" :maxlength="200"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import Config from "../../../config";
import { idNoRegular } from "../../../utils/regular";

export default {
  data() {
    return {
      cleanerId: null,
      faceVerifyModel: {
        display: false,
        status: "",
        faceReason: ""
      },
      cardInfo: {
        isAuth: "",
        cardBackImg: "", //反面
        cardFrontImg: "" //正面
      },
      faceInfo: {
        isFaceRecognized: "",
        faceRecognitionImg: ""
      },
      cardVerifyModel: {
        display: false,
        data: {
          name: "",
          cardId: "",
          status: "",
          cardReason: ""
        }
      },
      cardVerRules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        cardId: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: idNoRegular,
            message: "证件号码格式不正确",
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            type: "number",
            message: "请选择审核状态",
            trigger: "change"
          }
        ],
        cardReason: [{ required: true, message: "请填写原因", trigger: "blur" }]
      },
      faceVerRules: {
        faceReason: [{ required: true, message: "请填写原因", trigger: "blur" }]
      },
      btnLoading: {
        omsCardBtn: false,
        omsFaceBtn: false
      }
    };
  },
  mounted() {
    this.userCheckInfos();
  },
  created() {
    this.cleanerId = Utils.getUrlParameterByName("id");
    this.token = Utils.findFromLocalStorage("vue-token");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.imgHost = Config[this.env].imgHost;
  },
  methods: {
    // 获取页面信息
    async userCheckInfos() {
      let resp = (await API.omsAPI[this.env].cleaner.getVerifyInfo(
        { id: this.cleanerId },
        this.token
      )).data;
      if (!resp.retCode) {
        this.cardInfo = resp;
        this.faceInfo = resp;
      }
    },
    // 页面弹窗
    cardVerifyBtn() {
      if (this.cardInfo.cardBackImg && this.cardInfo.cardFrontImg) {
        this.cardVerifyModel.display = true;
      } else {
        this.$Notice.info({
          title: "请先上传身份证正反面照片"
        });
      }
    },
    faceVerifyBtn() {
      if (this.cardInfo.isAuth == 1) {
        if (this.faceInfo.faceRecognitionImg) {
          this.faceVerifyModel.display = true;
        } else {
          this.$Notice.info({
            title: "请先上传人脸识别照片"
          });
        }
      } else {
        this.$Notice.info({
          title: "请先验证身份证"
        });
      }
    },
    // 人工人脸审核
    async subFace() {
      let validResult = false;
      this.$refs.faceVerifyForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.faceVerifyModel.buttonLoading = false;
        return;
      }
      let params = {
        id: this.cleanerId,
        recognitionFailReason: this.faceVerifyModel.faceReason,
        isFaceRecognized: this.faceVerifyModel.status,
        updateName:this.username
      };
      let resp = (await API.omsAPI[this.env].cleaner.editCleanerList(
        params,
        this.token
      )).data;
      if (resp.retCode) {
        this.$refs.faceVerifyModel.buttonLoading = false;
        this.$Notice.error({
          title: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "操作成功"
        });
        this.faceVerifyModel.display = false;
        this.userCheckInfos();
      }
    },
    // 人工身份证审核
    async subCard() {
      let validResult = false;
      this.$refs.cardVerifyForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.cardVerifyModel.buttonLoading = false;
        return;
      }
      let params = {
        id: this.cleanerId,
        userName: this.cardVerifyModel.data.name,
        cardId: this.cardVerifyModel.data.cardId,
        authFailReason: this.cardVerifyModel.data.cardReason,
        isAuth: this.cardVerifyModel.data.status,
        updateName:this.username
      };
      let resp = (await API.omsAPI[this.env].cleaner.editCleanerList(
        params,
        this.token
      )).data;
      if (resp.retCode) {
        this.$refs.cardVerifyModel.buttonLoading = false;
        this.$Notice.error({
          title: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "操作成功"
        });
        this.cardVerifyModel.display = false;
        this.userCheckInfos();
      }
    },
    // 使用照片审核
    async omsCardAudit() {
      this.btnLoading.omsCardBtn = true;
      let resp = (await API.omsAPI[this.env].cleaner.authentication(
        {
          cleanerId: this.cleanerId,
          cardBackImgCode: this.cardInfo.cardBackImg,
          cardFrontImgCode: this.cardInfo.cardFrontImg,
          updateName: this.username
        },
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
        this.btnLoading.omsCardBtn = false;
      } else {
        this.$Notice.success({
          title: "操作成功"
        });
        this.btnLoading.omsCardBtn = false;
      }
      this.userCheckInfos();
    },
    async omsFaceAudit() {
      this.btnLoading.omsFaceBtn = true;
      let resp = (await API.omsAPI[this.env].cleaner.faceRecognition(
        {
          cleanerId: this.cleanerId,
          imageCode: this.faceInfo.faceRecognitionImg
        },
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
        this.btnLoading.omsFaceBtn = false;
      } else {
        this.$Notice.success({
          title: "操作成功"
        });
        this.btnLoading.omsFaceBtn = false;
      }
      this.userCheckInfos();
    },
    // 身份证正面上传
    cardImgFirstBeforeUpload(file) {
      if (this.cardInfo.isAuth == 1 || this.cardInfo.isAuth == 2) {
        this.$Notice.warning({
          title: "审核状态为(验证中/已验证)不可上传照片"
        });
      } else {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          file.url = reader.result;
          // 照片压缩
          this.canvasDataURL(reader.result, {}, base64UrlCheck => {
            let imgUrl = base64UrlCheck.split(",")[1];
            this.cardInfo.cardFrontImg = imgUrl;
          });
        };
      }
      return false;
    },
    cardImgFirstFormatError() {
      this.$Notice.warning({
        title: "文件类型不正确（'只能上传jpg、jpeg、png格式'）"
      });
    },
    // 身份证反面上传
    cardImgSecondBeforeUpload(file) {
      if (this.cardInfo.isAuth == 1 || this.cardInfo.isAuth == 2) {
        this.$Notice.warning({
          title: "审核状态为(验证中/已验证)不可上传照片"
        });
      } else {
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend = () => {
          file.url = reader.result;
          // 照片压缩
          this.canvasDataURL(reader.result, {}, base64UrlBack=> {
            let imgUrl = base64UrlBack.split(",")[1];
            this.cardInfo.cardBackImg = imgUrl;
          });
        };
      }
      return false;
    },
    cardImgSecondFormatError() {
      this.$Notice.warning({
        title: "文件类型不正确（'只能上传jpg、jpeg、png格式'）"
      });
    },
    // 人脸识别照片上传
    faceImgBeforeUpload(file) {
      if (this.faceInfo.isFaceRecognized == 2) {
        this.$Notice.warning({
          title: "审核状态为(已验证)不可上传照片"
        });
      } else {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          file.url = reader.result;
          // 照片压缩
          this.canvasDataURL(reader.result, {}, base64Url => {
            let imgUrl = base64Url.split(",")[1];
            this.faceInfo.faceRecognitionImg = imgUrl;
          });
        };
      }
      return false;
    },
    /**
     * @param obj:{}
     * @param quality 压缩质量
     * @param width 压缩后宽度
     * @param height 压缩后高度
     */
    canvasDataURL(path, obj, callback) {
      let img = new Image();
      img.src = path;
      img.onload = function() {
        let that = this;
        // 默认按比例压缩
        let w = that.width,
          h = that.height,
          scale = w / h;
        w = obj.width || w;
        h = obj.height || w / scale;
        let quality = 0.7; // 默认图片质量为0.7
        //生成canvas
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        // 创建属性节点
        let anw = document.createAttribute("width");
        anw.nodeValue = w;
        let anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        let base64 = canvas.toDataURL("image/jpeg", quality);
        // 回调函数返回base64的值
        callback(base64);
      };
    },
    faceImgFormatError() {
      this.$Notice.warning({
        title: "文件类型不正确（'只能上传jpg、jpeg、png格式'）"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h5 {
  text-align: center;
  margin-bottom: 5px;
}
.upload {
  text-align: center;
  cursor: pointer;
  .upload-box {
    padding-top: 60px;
  }
  .img-box {
    position: relative;
    width: 300px;
    height: 190px;
    padding-top: 0;
    background-color: #eee;
  }
}
.upload-box {
  display: inline-block;
  width: 300px;
  height: 190px;
  border: 1px solid #eee;
  background-color: #eee;
}
.upload-bord {
  position: absolute;
  top: 0;
  padding-top: 60px;
  width: 300px;
  height: 190px;
  opacity: 0;
  background-color: #bcbcbc;
}
.upload-bord:hover {
  opacity: 0.8;
}
.cardImg {
  text-align: center;
}
.tableForm {
  margin-bottom: 0;
}
img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/housekeeper-account-edit/check-id.vue